module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6L2lR"))).then(() => parcelRequire('cvs7o'));